import { useState, useEffect } from 'react';
import { useSignup } from '../hooks/useSignup';
import { useSearchParams } from 'react-router-dom';
import './Signup.css'; // Importeer het CSS-bestand

const Signup = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPasswordField, setShowPasswordField] = useState(false);
  const [logoSrc, setLogoSrc] = useState('/wpk-logo.svg'); // Standaard logo
  const { signup, checkEmail, error, isLoading } = useSignup();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const referrer = searchParams.get('ref');
    if (referrer === 'wpk') {
      setLogoSrc('/wpk-logo.svg');
    } else if (referrer === 'pvangeest') {
      setLogoSrc('/p-van-geest-plantenkwekerij-logo_100px.png');
    }
  }, [searchParams]);

  const handleCheckEmail = async (e) => {
    e.preventDefault();
    const emailExists = await checkEmail(email.toLowerCase());
    if (emailExists) {
      setShowPasswordField(true);
    }
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    await signup(email.toLowerCase(), password);
  };

  return (
    <div className="signup-container">
      <form
        className="signup-form"
        onSubmit={showPasswordField ? handleSignup : handleCheckEmail}
      >
        <div className="logo-container">
          <img src={logoSrc} alt="Logo" className="logo" />
        </div>
        <h3>Wachtwoord instellen</h3>
        <p>
          Voer hier uw e-mailadres in dat u gebruikt om in te loggen op het
          Klantenportaal. Als dit wordt herkend, kunt u uw nieuwe wachtwoord
          invoeren.
        </p>
        <div
          style={{
            backgroundColor: "#f2f2f2",
            padding: "6px",
            borderRadius: "12px",
            marginBottom: "12px",
          }}
        >
        <h4>Set password</h4>
        <p style={{ fontSize: "80%" }}>
          Enter the e-email address that you use to login on the portal. <br />If this is recognized, you can set your new password.
        </p>
        </div>
        <label>Email:</label>
        <input
          type="email"
          placeholder="info@bedrijf.com"
          onChange={(e) => setEmail(e.target.value)}
          value={email}
          required
          className="input-field"
        />
        {showPasswordField && (
          <>
            <label>Wachtwoord voor Klantenportaal:</label>
            <input
              type="password"
              onChange={(e) => setPassword(e.target.value)}
              value={password}
              required
              className="input-field"
            />
          </>
        )}
        <button disabled={isLoading} className="submit-button">
          {showPasswordField ? 'Instellen' : 'Check Email'}
        </button>
        {error && <div className="error-message">{error}</div>}
      </form>
    </div>
  );
};

export default Signup;
